module.exports = __webpack_public_path__ + "static/media/CEDRA SALAME .dc5c86dd.png";